let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jdjSr"), load("3KZyj"), load("kDPsc"), load("fRrg0")]).then(() => parcelRequire('7aApD'));